import { render, staticRenderFns } from "./actions-column.vue?vue&type=template&id=71ce76dc"
import script from "./actions-column.vue?vue&type=script&lang=js"
export * from "./actions-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71ce76dc')) {
      api.createRecord('71ce76dc', component.options)
    } else {
      api.reload('71ce76dc', component.options)
    }
    module.hot.accept("./actions-column.vue?vue&type=template&id=71ce76dc", function () {
      api.rerender('71ce76dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/conversations/actions-column.vue"
export default component.exports